import { Box, Heading, Text, Link, OrderedList, ListItem } from "@chakra-ui/react";
import * as React from "react";

export default function AccountDeletionInfoPage() {
    return (
        <Box maxW="800px" mx="auto" p={8}>
            <Heading as="h1" size="lg" mb={4}>
                Eliminazione dell'Account – SmartVenues / Enoteca Regionale
            </Heading>

            <Text mb={4}>
                L'app <strong>SmartVenues / Enoteca Regionale</strong> è sviluppata per conto di <strong>Cerisvi</strong>.
                Puoi eliminare definitivamente il tuo account e tutti i dati personali associati seguendo i passaggi riportati di seguito.
            </Text>

            <OrderedList mb={4} spacing={2}>
                <ListItem>Apri l'app sul tuo dispositivo.</ListItem>
                <ListItem>
                    Vai su <strong>Profilo → Elimina il mio account</strong>.
                </ListItem>
                <ListItem>Conferma la richiesta di eliminazione.</ListItem>
            </OrderedList>

            <Text mb={4}>
                L'eliminazione dell'account è immediata e <strong>irreversibile</strong>. Tutti i tuoi dati verranno rimossi in modo permanente dai nostri sistemi.
            </Text>

            <Text mb={4}>
                I dati memorizzati includono: <strong>email, password, nome, cognome e numero di telefono</strong>.
                Non vengono conservati ulteriori dati dopo la cancellazione dell'account.
            </Text>

            <Text>
                Se riscontri problemi o non riesci ad accedere all'app, puoi contattarci via email a{" "}
                <Link color="blue.500" href="mailto:info@enjoyetna.com">
                    info@enjoyetna.com
                </Link>
                .
            </Text>
        </Box>
    );
}
